import { render, staticRenderFns } from "./UserProfileImage.vue?vue&type=template&id=6b248846&scoped=true&v-if=ifPresent%20%26%26%20imgUrl&"
import script from "./UserProfileImage.vue?vue&type=script&lang=js&"
export * from "./UserProfileImage.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileImage.vue?vue&type=style&index=0&id=6b248846&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b248846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b248846')) {
      api.createRecord('6b248846', component.options)
    } else {
      api.reload('6b248846', component.options)
    }
    module.hot.accept("./UserProfileImage.vue?vue&type=template&id=6b248846&scoped=true&v-if=ifPresent%20%26%26%20imgUrl&", function () {
      api.rerender('6b248846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/User/UserProfileImage.vue"
export default component.exports